@if (addressString && consumptionIconLabels) {
  <span class="label item" wlCSCapture>{{ label }}</span>
  <span class="address item" wlCSMask>{{ addressString }}</span>
  <div class="consumptions item">
    @for (consumptionLabel of consumptionIconLabels; track consumptionLabel) {
      <div>
        <crnt-icon
          class="brand === ed ? text-brand : text-brand-alt"
          [icon]="consumptionLabel.icon"
          square="true"
        ></crnt-icon>
        <span>{{ consumptionLabel.label }}</span>
      </div>
    }
    <button
      (click)="adjustCalculation.emit()"
      class="btn btn-link adjust-calculation"
      wlAutomationId="change-calculation-button"
      wlCSCapture
    >
      {{ adjustCalculationLabel }}
    </button>
  </div>
}
